import { exists } from '@/api'

export interface BatchExpiredUserListCondition {
  userRegistrationDateFrom: string
  userRegistrationDateTo: string
  userExpirationDateFrom: string
  userExpirationDateTo: string
  userRegistrationBranchCode: string
  order: string
  userType: string
  outputStatistics: boolean
}

export function BatchExpiredUserListConditionFromJSON(
  json: any
): BatchExpiredUserListCondition {
  const _json = JSON.parse(json)

  return {
    userRegistrationDateFrom: exists(_json, 'user_registration_date_from')
      ? _json.user_registration_date_from
      : '',
    userRegistrationDateTo: exists(_json, 'user_registration_date_to')
      ? _json.user_registration_date_to
      : '',
    userExpirationDateFrom: exists(_json, 'user_expiration_date_from')
      ? _json.user_expiration_date_from
      : '',
    userExpirationDateTo: exists(_json, 'user_expiration_date_to')
      ? _json.user_expiration_date_to
      : '',
    userRegistrationBranchCode: exists(_json, 'user_registration_branch_code')
      ? _json.user_registration_branch_code
      : '',
    order: exists(_json, 'order') ? _json.order : '1',
    userType: exists(_json, 'user_type') ? _json.user_type : '1',
    outputStatistics: exists(_json, 'output_statistics')
      ? _json.output_statistics
      : false
  }
}
